import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GridState,
  GridStateCompositeFilterDescriptor,
  MessageService,
} from '@shared';
import {
  Alerts,
  AlertsService,
  GlobalEventsService,
  IChangeset,
  ItemService,
} from '@shared-data';
import { TokenService } from '@auth';
import { CategoryConstants } from '../../constants';
import { DataSource } from '@angular/cdk/collections';
import { GridDataResult } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-alerts-banner',
  templateUrl: './alerts-banner.component.html',
  styleUrl: './alerts-banner.component.scss',
})
export class AlertsBannerComponent implements OnInit {
  alerts?: Alerts;

  changes: IChangeset[] = [];

  scheduledChangesVisible: boolean = false;

  ltoPopupVisible = false;

  acknowledgementVisible: boolean = false;

  newLtos: GridDataResult = { data: [], total: 0 };

  isAvailabilityOnly: boolean = false;

  constructor(
    private alertService: AlertsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private globalEventsService: GlobalEventsService,
    private messageService: MessageService,
    private itemService: ItemService,
    private tokenService: TokenService,
  ) {}

  async ngOnInit() {
    this.isAvailabilityOnly = await this.tokenService.isAvailabilityOnly();
    this.getAlerts();
    this.subscribeToNavigateAwayFromLTO();
  }

  getAlerts() {
    this.alertService.getAlerts().subscribe({
      next: (alerts) => {
        this.alerts = alerts;
        // Don't show LTO alerts for AvailabilityOnly users (LTOs are pricing-related)
        if (alerts.newLtoCount > 0 && !this.isAvailabilityOnly) {
          this.ltoPopupVisible = true;
          const filter = new GridStateCompositeFilterDescriptor().and({
            field: 'categoryName',
            operator: 'eq',
            value: CategoryConstants.LTO,
          });
          const state = new GridState(1000);
          state.filter = filter;
          this.itemService.getNewPreview(state).subscribe({
            next: (preview: GridDataResult) => {
              this.newLtos = preview;
              this.ltoPopupVisible = true;
            },
            error: (error: any) => {
              this.messageService.error('Error fetching new LTO preview');
            },
          });
        }
      },
    });
  }

  navigateToReport() {
    this.router.navigate(['/reports/history'], {
      relativeTo: this.activatedRoute,
    });
  }

  navigateToLtos() {
    this.router.navigate(['/restaurantitem/pricing/lto'], {
      relativeTo: this.activatedRoute,
      queryParams: { isLto: true },
    });
  }

  acknowledgeLtos() {
    this.alertService.acknowledgeLtoAlert().subscribe({
      next: (response) => {
        this.getAlerts();
      },
      error: (error) => {
        this.messageService.error('Error acknowledging LTO alert');
      },
    });
  }

  subscribeToNavigateAwayFromLTO() {
    this.globalEventsService.navigatedAwayFromLTO$.subscribe(() => {
      this.acknowledgementVisible = true;
    });
  }

  downloadDocument(
    newItem: { itemName: string; parItemId: number },
    documentPath: string,
  ) {
    this.itemService.downloadDocument(documentPath).subscribe({
      next: async (response: { url: string }) => {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = response.url;
        downloadLink.download = `${newItem.itemName}_${newItem.parItemId}.pdf`; // Suggest a filename
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      },
      error: (error) => {
        this.messageService.error('Error downloading document');
      },
    });
  }
}
